import { useEffect, useState } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CheckCircle, CheckIcon, XCircleIcon } from "lucide-react";

const AfterRegistration = () => {
  const [searchParams] = useSearchParams(window.location.search);

  const email = searchParams.get("email");
  const [message, setMessage] = useState({
    message: "",
    success: false
  })
  useEffect(() => {
    const handleVerification = async () => {
      const verificationUrl = `${process.env.REACT_APP_API}/users-api/email_verify/`;

      const body = {
        data: decodeURIComponent(email),
      };

      try {
        const response = await axios.post(verificationUrl, body);
        let linkSuccessMsg = response.data.status;
        toast.success(linkSuccessMsg);
        setMessage({ message: "Verification Successful", success: true })
      } catch (error) {
        let linkErrorMsg = error.response.data.status;
        // toast.error(linkErrorMsg);
        setMessage({ message: linkErrorMsg, success: false })

      }
    };
    handleVerification();
  }, [email]);

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center">
      <div className="flex flex-col gap-2 items-center">
        {message?.success ? <CheckCircle color="green" size={100} /> : <XCircleIcon color="red" size={100} />}
        <p className="text-xl"> {message?.message}</p>
      </div>
    </div>
  )
};
export default AfterRegistration;
